import React from 'react';
import {gql} from "apollo-boost";
import {
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import {useQuery} from "@apollo/react-hooks";
import useStyles from '../../styles/styles';

/**
 * Could replace the original CloudwatchLogsTable once all leads use the short form lead pattern
 */
const CloudwatchLogsTableShortForm = ({id}) => {
    const classes = useStyles();
    const {loading, error, data} = useQuery(gql`
        query CloudwatchLogs($apiRequestId: UUID!) {
            cloudwatchLogs(apiRequestId: $apiRequestId) {
                id
                timestamp
                elapsedSeconds
                level
                message
                shortClass
                method
                line
                hash
            }
        }
    `, {
        variables: {
            apiRequestId: id,
        },
        context: {
            clientName: "kgraphql"
        }
    });

    if (loading) {
        return (
            <CircularProgress color="inherit"/>
        );
    }

    if (error) {
        return (
            <>
                <Typography variant="h4" component="h4" align="left" id={"cloudwatch-logs"}>Cloudwatch Logs</Typography>
                <Paper className={classes.paper}>
                    <Alert severity="error">Well, this in embarrassing&hellip; something went wrong.</Alert>
                </Paper>
            </>
        );
    }

    const logs = data.loanRequest ?? []

    return (
        <>
            <Typography variant="h4" component="h4" align="left" id={"cloudwatch-logs"}>Cloudwatch Logs
                ({logs.length})</Typography>
            <Paper className={classes.paper}>
                {logs.length ? (
                    <Table className={classes.table} size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell variant="head">Time</TableCell>
                                <TableCell variant="head">Message</TableCell>
                                <TableCell variant="head">Timestamp</TableCell>
                                <TableCell variant="head">Level</TableCell>
                                <TableCell variant="head">Source</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {logs.map(entry => (
                                <TableRow>
                                    <TableCell variant="body">{entry.elapsedSeconds}</TableCell>
                                    <TableCell variant="body">{entry.message}</TableCell>
                                    <TableCell variant="body">{entry.timestamp}</TableCell>
                                    <TableCell variant="body">{entry.level}</TableCell>
                                    <TableCell
                                        variant="body">{entry.shortClass}.{entry.method}()@{entry.line}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                ) : (
                    <Alert severity="warning">There are no Cloudwatch Logs at this time.</Alert>
                )
                }
            </Paper>
        </>
    );
};

export default CloudwatchLogsTableShortForm;
